import {OrderCommentCommand} from '@domain/model/Order/OrderCommentCommand';
import {PromoCodeForOrder} from '@domain/model/Order/PromoCodeForOrder';

import {executeMutation} from '@infra/api/graphQL/client';
import {Mutations} from '@infra/api/graphQL/domain/model/Order/mutations';
import {OrderRepository} from '@domain/model/Order/OrderRepository';

export type PromoCodeResponse = Record<string, PromoCodeForOrder>;

const updateOrderComment = async (comment: OrderCommentCommand): Promise<Record<string, boolean>> => {
  try {
    return await executeMutation<Record<string, boolean>>(Mutations.UPDATE_ORDER_COMMENT, comment);
  } catch (e) {
    return Promise.reject(e);
  }
};

const cancelOrder = (): Promise<Record<string, boolean>> =>
  executeMutation<Record<string, boolean>>(Mutations.CANCEL_ORDER, {});

const ApiOrderRepository: OrderRepository = {
  cancelOrder,
  updateOrderComment,
};

export {ApiOrderRepository};
